var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body uk-width-expand"},[_c('request',{staticStyle:{"background-color":"#ff6"},attrs:{"request":_vm.displayMessage,"highlight":_vm.noCheckingJob}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"material-icons"},[_vm._v("comment")]),_vm._v("\n        발송작업 요청메모\n    ")])
}]

export { render, staticRenderFns }